import { useTranslation } from "react-i18next";
import Select, { StylesConfig } from "react-select";

const inputContainerClass = "w-full flex flex-col gap-1";
const inputLabelClass = "text-sm font-semibold";
const inputClass =
  "w-full rounded-xl border-[1px] border-stone-300 placeholder:text-sendolab-gray5 py-2 px-3 outline-business-green text-sm";
const selectClass = "[&>div]:rounded-xl text-sm";

const selectCustomStyles: StylesConfig = {
  control: (styles) => ({
    ...styles,
    minHeight: "2.5rem",
    ":active": {
      borderColor: "#a8b07d",
      boxShadow: "0 0 0 1px #a8b07d",
    },
    ":focus": {
      borderColor: "#a8b07d",
      boxShadow: "0 0 0 1px #a8b07d",
    },
    ":focus-within": {
      borderColor: "#a8b07d",
      boxShadow: "0 0 0 1px #a8b07d",
    },
    ":hover": {
      borderColor: "#a8b07d",
      boxShadow: "0 0 0 1px #a8b07d",
    },
  }),
  multiValue: (styles) => ({
    ...styles,
    borderRadius: "6px",
    backgroundColor: "#a8b07d",
    color: "white",
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    color: "white",
  }),
};

export const SalesforceContactForm = () => {
  const [tBusiness] = useTranslation("business");

  const businessOptions = [
    {
      value: "Business Account to Business Account (B2B)",
      label: "Business Account to Business Account (B2B)",
    },
    {
      value: "Business Account to Personal Account (B2P)",
      label: "Business Account to Personal Account (B2P)",
    },
    {
      value: "Personal Account to Business Account (P2B)",
      label: "Personal Account to Business Account (P2B)",
    },
  ];
  const expectedCountriesOptions = [
    {
      value: "Argentina",
      label: "Argentina",
    },
    {
      value: "Brazil",
      label: "Brazil",
    },
    {
      value: "Canada",
      label: "Canada",
    },
    {
      value: "Colombia",
      label: "Colombia",
    },
    {
      value: "Ecuador",
      label: "Ecuador",
    },
    {
      value: "Guatemala",
      label: "Guatemala",
    },
    {
      value: "Honduras",
      label: "Honduras",
    },
    {
      value: "Mexico",
      label: "Mexico",
    },
    {
      value: "Austria",
      label: "Austria",
    },
    {
      value: "Belgium",
      label: "Belgium",
    },
    {
      value: "Portugal",
      label: "Portugal",
    },
    {
      value: "South Africa",
      label: "South Africa",
    },
    {
      value: "España",
      label: "España",
    },
    {
      value: "United States",
      label: "United States",
    },
    {
      value: "Bulgaria",
      label: "Bulgaria",
    },
    {
      value: "Croatia",
      label: "Croatia",
    },
    {
      value: "Cyprus",
      label: "Cyprus",
    },
    {
      value: "Czech Republic",
      label: "Czech Republic",
    },
    {
      value: "Denmark",
      label: "Denmark",
    },
    {
      value: "Estonia",
      label: "Estonia",
    },
    {
      value: "Finland",
      label: "Finland",
    },
    {
      value: "France",
      label: "France",
    },
    {
      value: "Germany",
      label: "Germany",
    },
    {
      value: "Greece",
      label: "Greece",
    },
    {
      value: "Hungary",
      label: "Hungary",
    },
    {
      value: "Ireland",
      label: "Ireland",
    },
    {
      value: "Italy",
      label: "Italy",
    },
    {
      value: "Latvia",
      label: "Latvia",
    },
    {
      value: "Liechtenstein",
      label: "Liechtenstein",
    },
    {
      value: "Lithuania",
      label: "Lithuania",
    },
    {
      value: "Luxemburg",
      label: "Luxemburg",
    },
    {
      value: "Malta",
      label: "Malta",
    },
    {
      value: "Monaco",
      label: "Monaco",
    },
    {
      value: "Netherlands",
      label: "Netherlands",
    },
    {
      value: "Norway",
      label: "Norway",
    },
    {
      value: "Poland",
      label: "Poland",
    },
    {
      value: "Slovakia",
      label: "Slovakia",
    },
    {
      value: "Slovenia",
      label: "Slovenia",
    },
    {
      value: "Sweden",
      label: "Sweden",
    },
    {
      value: "Switzerland",
      label: "Switzerland",
    },
    {
      value: "United Kingdom",
      label: "United Kingdom",
    },
    {
      value: "Australia",
      label: "Australia",
    },
  ];

  const prefferedContactOptions = [
    {
      value: "Phone",
      label: "Phone",
    },
    {
      value: "Email",
      label: "Email",
    },
  ];

  const timezoneOptions = [
    {
      value: "Eastern Standard Time (EST) - UTC-5",
      label: "Eastern Standard Time (EST) - UTC-5",
    },
    {
      value: "Central Standard Time (CST) - UTC-6",
      label: "Central Standard Time (CST) - UTC-6",
    },
    {
      value: "Mountain Standard Time (MST) - UTC-7",
      label: "Mountain Standard Time (MST) - UTC-7",
    },
    {
      value: "Pacific Standard Time (PST) - UTC-8",
      label: "Pacific Standard Time (PST) - UTC-8",
    },
    {
      value: "Alaska Standard Time (AKST) - UTC-9",
      label: "Alaska Standard Time (AKST) - UTC-9",
    },
    {
      value: "Hawaii-Aleutian Standard Time (HAST) - UTC-10",
      label: "Hawaii-Aleutian Standard Time (HAST) - UTC-10",
    },
    {
      value: "Atlantic Standard Time (AST) - UTC-4",
      label: "Atlantic Standard Time (AST) - UTC-4",
    },
    {
      value: "Newfoundland Standard Time (NST) - UTC-3:30",
      label: "Newfoundland Standard Time (NST) - UTC-3:30",
    },
  ];

  return (
    <form
      className="flex flex-col gap-5 w-full items-center"
      action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00DKd00000AXcwY"
      method="POST"
    >
      <p className="font-medium text-lg lg:text-xl text-center w-full">
        {tBusiness("Contact.Form.Title")}
      </p>

      <div className={inputContainerClass}>
        <input type="hidden" name="oid" value="00DKd00000AXcwY" />
        <input
          type="hidden"
          name="retURL"
          value="https://sendola.com/business"
        />
        <input type="hidden" name="lead_source" value="Website" />
      </div>
      {/* 
        NOTE: These fields are optional debugging elements. Please uncomment these
        lines if you wish to test in debug mode.
        <input type="hidden" name="debug" value={1} />
        <input type="hidden" name="debugEmail" value="andres@sendola.io" />
      */}

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full">
        <div className={inputContainerClass}>
          <label className={inputLabelClass} htmlFor="first_name">
            {tBusiness("Contact.Form.Name")}
          </label>
          <input
            className={inputClass}
            id="first_name"
            maxLength={40}
            name="first_name"
            size={20}
            type="text"
            required
          />
        </div>

        <div className={inputContainerClass}>
          <label className={inputLabelClass} htmlFor="last_name">
            {tBusiness("Contact.Form.LastName")}
          </label>
          <input
            className={inputClass}
            id="last_name"
            maxLength={80}
            name="last_name"
            size={20}
            type="text"
            required
          />
        </div>
      </div>

      <div className={inputContainerClass}>
        <label className={inputLabelClass} htmlFor="company">
          {tBusiness("Contact.Form.BusinessName")}
        </label>
        <input
          className={inputClass}
          id="company"
          maxLength={40}
          name="company"
          size={20}
          type="text"
          required
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full">
        <div className={inputContainerClass}>
          <label className={inputLabelClass} htmlFor="email">
            {tBusiness("Contact.Form.Email")}
          </label>
          <input
            className={inputClass}
            id="email"
            maxLength={80}
            name="email"
            size={20}
            type="text"
            required
          />
        </div>

        <div className={inputContainerClass}>
          <label className={inputLabelClass} htmlFor="phone">
            {tBusiness("Contact.Form.Phone")}
          </label>
          <input
            className={inputClass}
            id="phone"
            maxLength={40}
            name="phone"
            size={20}
            type="text"
            required
          />
        </div>
      </div>

      <div className={inputContainerClass}>
        <label className={inputLabelClass}>
          {tBusiness("Contact.Form.TransactionTypes")}
        </label>
        <Select
          id="00NKd00000sM6OP"
          name="00NKd00000sM6OP"
          placeholder={tBusiness("Contact.Form.SelectPlaceholder")}
          closeMenuOnSelect={false}
          className={selectClass}
          styles={selectCustomStyles}
          isMulti
          isSearchable={false}
          options={businessOptions}
        />
      </div>

      <div className={inputContainerClass}>
        <label className={inputLabelClass}>
          {tBusiness("Contact.Form.ExpectedCountries")}
        </label>
        <Select
          id="00NKd00000sM6Gj"
          name="00NKd00000sM6Gj"
          placeholder={tBusiness("Contact.Form.SelectPlaceholder")}
          closeMenuOnSelect={false}
          className={selectClass}
          styles={selectCustomStyles}
          isMulti
          isSearchable={false}
          options={expectedCountriesOptions}
        />
        <p className="text-xs text-light text-stone-700 max-w-[80%] md:max-w-[60%]">
          {tBusiness("Contact.Form.CountriesDisclaimer")}
        </p>
      </div>

      <div className={inputContainerClass}>
        <label className={inputLabelClass}>
          {tBusiness("Contact.Form.PreferredChannel")}
        </label>
        <div className="flex items-center gap-6 mt-3">
          {prefferedContactOptions.map((option) => (
            <div className="flex gap-1 items-center">
              <input
                type="radio"
                id="00NKd00000sM6OU"
                name="00NKd00000sM6OU"
                value={option.value}
                className="w-6 h-6 checked:border-business-green checked:border-8 transition-all border-[1px] border-gray-300 rounded-full appearance-none"
              />
              <label className="font-light text-gray-500 text-sm">
                {option.label}
              </label>
            </div>
          ))}
        </div>
      </div>

      <div className={inputContainerClass}>
        <label className={inputLabelClass}>
          {tBusiness("Contact.Form.Timezone")}
        </label>
        <Select
          id="00NKd00000sM6Oe"
          name="00NKd00000sM6Oe"
          placeholder={tBusiness("Contact.Form.SelectPlaceholder")}
          className={selectClass}
          styles={selectCustomStyles}
          isSearchable={false}
          isClearable
          options={timezoneOptions}
        />
      </div>

      <div className={inputContainerClass}>
        <p className={inputLabelClass}>
          {tBusiness("Contact.Form.Confirmation")}
        </p>
        <p className="text-xs text-light text-stone-700 mt-6">
          {tBusiness("Contact.Form.Disclaimer")}
        </p>

        <div className="flex font-light items-center gap-4 mt-4">
          <input
            type="checkbox"
            className="w-8 h-8 accent-current rounded transition-all"
            required
          />
          <p className="text-sm">
            {tBusiness("Contact.Form.Checkbox")}&nbsp;
            <a
              className="font-semibold underline underline-offset-1"
              href="https://s3.us-west-1.amazonaws.com/sendola.io/Disclosures+y+Legales+/Sendola.io/Sendola+Terms+of+Service++(8092025).pdf"
            >
              {tBusiness("Contact.Form.Terms")},
            </a>
            &nbsp;
            <a
              className="font-semibold underline underline-offset-1"
              href="https://s3.us-west-1.amazonaws.com/sendola.io/Disclosures+y+Legales+/Sendola.io/PrivacyPolicy.pdf"
            >
              {tBusiness("Contact.Form.Privacy")}
            </a>
            &nbsp;
            <span>{tBusiness("Contact.Form.And")}</span>
            &nbsp;
            <a
              className="font-semibold underline underline-offset-1"
              href="https://s3.us-west-1.amazonaws.com/sendola.io/Disclosures+y+Legales+/Sendola.io/ElectronicCommunicationsDisclosuresandAgreement.pdf"
            >
              {tBusiness("Contact.Form.ElectronicAgreement")}
            </a>
          </p>
        </div>
      </div>

      <button
        className="text-sm bg-business-green rounded-xl px-10 py-2 w-fit text-white mt-8 cursor-pointer hover:opacity-90 disabled:opacity-60 disabled:cursor-not-allowed"
        type="submit"
      >
        {tBusiness("Contact.Form.Submit")}
      </button>
    </form>
  );
};
